import {useRef} from "react";
import Alert from 'react-bootstrap/Alert';
import Button from 'react-bootstrap/Button';
import FloatingLabel from "react-bootstrap/FloatingLabel";
import Form from 'react-bootstrap/Form';
import Modal from "react-bootstrap/Modal";
import {useTranslation} from "react-i18next";
import {useSearchParams} from "react-router-dom";
import {Utils} from "../utils/Utils";
import {SavedLocation} from "./SavedLocation";
import {XSRF} from "./Xsrf";

export const PortalLogin = () =>
{
    const [searchParams] = useSearchParams();

    /**
     * A ref to the hidden _csrf form field
     */
    const csrFieldRef = useRef<HTMLInputElement>(null);

    const loginURL: string = "/api/login"

    /**
     * i18next translation hook
     */
    const {t} = useTranslation('components');

    // back-end will add the logout parameter when the user is logged out
    if (searchParams.has("logout")) {
        SavedLocation.clearSavedLocation();
    }

    function onSubmit()
    {
        if (csrFieldRef.current !== null) {
            csrFieldRef.current.value = XSRF.generateCookie();
        }
    }

    return (
        <Modal show={true} centered={true} animation={false}>
            <Form method="post" action={loginURL} onSubmit={onSubmit}>
                <Modal.Header>
                    <Modal.Title className="w-100">{t('portal-login.title')}</Modal.Title>
                    <img src={Utils.createPublicHostResourceUrl("login-logo")} width="150" alt="CipherMail Logo"
                         className="float-right"/>
                </Modal.Header>
                <Modal.Body>
                    {searchParams.has("error") && <Alert variant="danger">{t('portal-login.login-failure')}</Alert>}

                    <FloatingLabel label={t('portal-login.email-label')} className="text-secondary mb-3">
                        <Form.Control type="email" name="username" placeholder="Email"/>
                    </FloatingLabel>

                    <FloatingLabel label={t('portal-login.password-label')} className="text-secondary mb-3">
                        <Form.Control type="password" name="password" placeholder="Password"/>
                    </FloatingLabel>

                    <a href="/forgot-password">{t('portal-login.forgot-password')}</a>

                    <input name="_csrf" type="hidden" ref={csrFieldRef} value=""/>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" type="submit">
                        {t('portal-login.login-button')}
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
}
